import React from "react";
import ProfileHeader from "./Headers/ProfileHeader";
import ListTeams from "./Team/ListTeams";
import DropdownOrgs from "./Org/DropdownOrgs";
import {useParams} from "react-router-dom";

function Home(props: { cognitoUser: any, realvrUser: any, loadData: any }) {
  const {cognitoUser, realvrUser, loadData} = props;
  // @ts-ignore
  const {orgId} = useParams();
  const selectedOrg = realvrUser.user.orgs.find((org: any) => org.id === orgId);
  const teams = selectedOrg ?
    <ListTeams teams={selectedOrg.teams} loadData={loadData}/>
    : <ListTeams teams={realvrUser.user.bookmarkedTeams} loadData={loadData}/>;
  const title = selectedOrg ?
    `${ellipsis(selectedOrg.name)} Villas`
    : 'My Villas';

  // TODO: move to lib and add a length param
  // TODO: make ProfileHeader ellipsis the content responsively
  function ellipsis(name: string) {
    if (name.length > 25) {
      return `${name.substr(0, 25)}…`;
    }
    return name;
  }

  const linkToHome = selectedOrg ? `/org/${selectedOrg.id}/villas` : '/my/villas';
  const homeImage = selectedOrg ? selectedOrg.imageUrl : null;

  return (
    <>
      <ProfileHeader cognitoUser={cognitoUser} title={title} linkToHome={linkToHome} image={homeImage}/>
      <section className="container main list-orgs p-4 rounded">
        <div className="row pb-4">
          <div className="col text-right">
            <DropdownOrgs orgs={realvrUser.user.orgs} selectedOrg={selectedOrg}/>
          </div>
        </div>
        {teams}
      </section>
    </>
  )
}

export default Home;
